import { render, staticRenderFns } from "./UserSelection.vue?vue&type=template&id=2c0acb50&scoped=true&"
import script from "./UserSelection.vue?vue&type=script&lang=ts&"
export * from "./UserSelection.vue?vue&type=script&lang=ts&"
import style0 from "./UserSelection.vue?vue&type=style&index=0&id=2c0acb50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0acb50",
  null
  
)

export default component.exports